<template>
    <div>
        <form id="contact-user" class="contact-form" action="" method="POST" @submit.prevent="submit" novalidate>
            <div class="input-section col-2">
                <form-input-type-text
                    name="name"
                    :label="__('First name')"
                    :errors="errors.name"
                    required
                    full-border
                ></form-input-type-text>
                <form-input-type-text name="surname" :label="__('Last name')" full-border></form-input-type-text>
            </div>

            <form-input-type-email
                name="email"
                :label="__('E-mail')"
                :errors="errors.email"
                required
                full-border
            ></form-input-type-email>

            <form-input-type-text
                v-if="isStudy"
                name="subject"
                :label="__('What is your request about?')"
                value="RWE Studie"
                readonly
                full-border
            ></form-input-type-text>

            <form-input-type-select
                v-else
                name="subject"
                :label="__('What is your request about?')"
                :options="selectOptions"
                :errors="errors.subject"
                :value="selectValue"
                required
                full-border
            ></form-input-type-select>

            <form-input-type-text-area
                name="text"
                :label="__('Message')"
                :errors="errors.text"
                required
                full-border
            ></form-input-type-text-area>


            <p class="form-mandatory-fields">{{ __('* Fields marked with an asterisk (*) are mandatory.') }}</p>

            <div class="input-section">
                <div class="form-footer">
                    <p
                        class="terms new-text-md"
                        v-html="__(getPrivacyText)"
                    ></p>
                    <div class="form-send">
                        <v-button :label="__('Send')" type="submit" size="lg" full-width></v-button>
                    </div>
                </div>
            </div>
        </form>

        <flash-alert
            v-if="showAlert"
            @closeAlert="close"
            :text="__('Thank you for your message. Someone from our team will get back to you soon! Have a nice day.')"
            position="top"
        ></flash-alert>
        <flash-alert
            v-if="failed"
            level="danger"
            @closeAlert="close"
            :text="__('Failed to send. Please try again.')"
            position="top"
        ></flash-alert>
    </div>
</template>

<script>
    import localforage from 'localforage'

    export default {
        props: {
            phoneCountry: {
                type: String,
                required: true,
                default: 'CS'
            },
            isStudy: {
                type: Boolean,
                required: false
            },
            mail: {
                type: String,
                default: 'podpora@vitad.io'
            }
        },
        data() {
            return {
                errors: {},
                showAlert: false,
                selectValue: null,
                showSelfPayerModal: true
            }
        },

        mounted() {
            $('.item-contact').addClass('active')

            let uri = new URI(location.href)

            if (uri.hasQuery('pkv-self-payer') === true) {
                this.selectValue = 'Rezeptanfrage PKV oder Selbstzahler'
                this.storage()
                setTimeout(() => {
                    this.showModal()
                }, 200)
            }

            var that = this

            localforage.getItem('contact-successfully-send', function (err, value) {
                if (value) {
                    that.showAlert = true

                    localforage.removeItem('contact-successfully-send')
                }
            })
        },
        computed: {
            email() {
                if (this.isStudy) {
                    return 'studie@vitadio.de'
                } else {
                    return this.mail
                }
            },
            failed() {
                if (this.errors && this.errors['g-recaptcha-response']) {
                    return true
                } else {
                    return false
                }
            },
            selectOptions() {
                if (this.phoneCountry == 'de') {
                    return [
                        { label: 'Fragen zur kostenlosen Rezeptanfrage' },
                        { label: 'Rezeptanfrage PKV oder Selbstzahler' },
                        { label: lang.get('Interested in registration') },
                        { label: lang.get('Adverse event reporting') },
                        { label: lang.get('Technical issues') },
                        { label: lang.get('Proposal for improving user experience') },
                        { label: lang.get('A career with Vitadio') },
                        { label: lang.get('Something else') }
                    ]
                } else {
                    return [
                        { label: lang.get('Interested in registration') },
                        { label: lang.get('Adverse event reporting') },
                        { label: lang.get('Technical issues') },
                        { label: lang.get('Proposal for improving user experience') },
                        { label: lang.get('A career with Vitadio') },
                        { label: lang.get('Something else') }
                    ]
                }
            },
            getPrivacyText() {
                let uri = new URI(location.href)

                if(uri.domain() === 'abnehmenmitdiabetes.de') {
                    return `Durch Eingabe Ihres Namens und Ihrer E-Mail-Adresse erklären Sie sich mit den Bestimmungen zum <a href='https://vitadio.de/datenschutzerklarung' target='_blank'>Datenschutz</a> einverstanden.`
                } else {
                    return `By entering your name and email you agree to our <a href='/privacy-policy' target='_blank'>Privacy Policy.</a>`
                }
            }
        },
        methods: {
            submit() {
                var that = this

                let formData = {
                    form_type: 'user_support'
                }

                grecaptcha.ready(function () {
                    grecaptcha
                        .execute('6Ld1xdAcAAAAADk0PETFBUMbW366obkv65EmHObU', { action: 'submit' })
                        .then(function (token) {
                            // serialize form data
                            $('#contact-user')
                                .serializeArray()
                                .forEach(({ name, value }) => {
                                    formData[name] = value
                                })

                            formData['g-recaptcha-response'] = token

                            axios
                                .post('api/contact-form', formData, {
                                    headers: {
                                        'Accept-Language': that.phoneCountry
                                    }
                                })
                                .then((e) => {
                                    localforage.setItem('show-self-payer-modal', true)
                                    localforage.setItem('contact-successfully-send', true)
                                    location.reload()
                                })
                                .catch((e) => {
                                    console.log(e.response)
                                    that.errors = e.response.data.errors
                                    Vuemit.fire('Button--sending-failed', true)
                                    this.scrollToError()
                                })
                        })
                })
            },

            storage() {
                if (this.showSelfPayerModal) {
                    var that = this
                    localforage.getItem('show-self-payer-modal', function (err, value) {
                        if (value) {
                            localforage.removeItem('show-self-payer-modal')
                            that.showSelfPayerModal = false
                        }
                    })
                }
            },

            showModal() {
                if (this.showSelfPayerModal) {
                    $('#modal-pkv-self').modal('show')
                }
            },

            close() {
                this.showAlert = false
            },

            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            }
        }
    }
</script>
